import React from "react";
import { useConversationsContext } from "../context/ConversationsListContext";
import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { routes, apiRoutes } from "../routes/routes";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaBars } from "react-icons/fa6";
import api from "../api";
import DeleteModal from "./DeleteModal";

export const ConversationsMenu = ({ clickConversation, newChat }) => {
  const { conversations, loadUserConversations, setConversations } =
    useConversationsContext();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [error, setError] = useState(null);
  const inputRefs = useRef({});
  const location = useLocation();
  const { uuid } = useParams();
  const navigate = useNavigate();

  const updateConversation = async (index, newTitle) => {
    const updated = [...conversations];
    updated[index].title = newTitle;
    setConversations(updated);
  };

  const deleteConversation = async (index) => {

    if(index === null ) return;

    const deletedUuid = conversations[index].uuid;

    try {
      const url = apiRoutes.conversation_details.replace(":uuid", deletedUuid);
      const response = await api.delete(url);
      if (response.status != 204) {
        throw new Error("Échec de la suppression");
      } else {
        const updated = conversations.filter((_, i) => i !== index);

        setConversations(updated);
        setDeleteIndex(null);

        if (
          location.pathname.startsWith(routes.chat.path) &&
          uuid === deletedUuid
        ) {
          navigate(routes.chat.path);
        }
      }
    } catch (error) {}
    finally {
      setShowDeleteModal(false);
    }
  };


  const openModal = (index) => {
    setDeleteIndex(index);
    setShowDeleteModal(true);

  }



  
  const handleRename = (index) => {
    setEditingIndex(index);
    setEditValue(conversations[index].title);
  };

  const handleBlur = async (index) => {
    // return;
    setEditingIndex(null);
    if (conversations[index].title !== editValue.trim()) {
      await updateConversation(index, editValue.trim());
    }
  };



  useEffect(() => {
    if (editingIndex && inputRefs.current[editingIndex]) {
      inputRefs.current[editingIndex]?.focus();
      inputRefs.current[editingIndex]?.select();
    }
  }, [editingIndex]);

  return (
    <div>
      <div className="nav flex-column">
        <div
          onClick={() => {
            newChat();
          }}
          className="btn btn-secondary"
        >
          New Chat
        </div>
      </div>

      <ul className="nav flex-column">
        {conversations.map((conversation, index) => (
          <li
            key={index}
            data-uuid={conversation.uuid}
            className="list-group-item d-flex justify-content-between align-items-center position-relative"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {editingIndex === index ? (
              <input
                ref={(el) => (inputRefs.current[index] = el)}
                id={`input-title-${index}`}
                className="form-control"
                value={editValue}
                // autoFocus
                onChange={(e) => setEditValue(e.target.value)}
                onBlur={() => handleBlur(index)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.target.blur();
                  }
                }}
              />
            ) : (
              <div
                className="nav-link text-primary d-flex align-items-center px-0"
                onClick={() => {
                  clickConversation(conversation);
                }}
              > 
              <div className="d-flex"
              >{
                conversation.data?.country_code && (
                  <span className={`h5 me-2 fi fi-${conversation.data.country_code.toLocaleLowerCase()}`}></span>
                )
              }
                {conversation.title}
                </div>
              </div>
            )}

            <div
              className={`dropdown ${
                hoveredIndex === index ? "d-block" : "d-none"
              }`}
            >
              <button
                className="btn btn-sm"
                type="button"
                id={`dropdownMenuButton-${index}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FaBars />
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby={`dropdownMenuButton-${index}`}
              >
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleRename(index)}
                  >
                    Renommer
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item text-danger"
                    onClick={() => openModal(index)}
                  >
                    Supprimer
                  </button>
                </li>
              </ul>
            </div>
          </li>
        ))}
      </ul>

      {/* Modal de confirmation de suppression */}
      <DeleteModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleDelete={deleteConversation}
        title={deleteIndex !== null ? conversations[deleteIndex]?.title : ''}
        index={deleteIndex}
      />

    </div>
  );
};
